export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";